"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mps_icon_library_1 = require("@imaginelearning/mps-icon-library");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
require("./scroll-button.scss");
var ScrollButton = function (props) { return (react_1.default.createElement("button", { className: "scroll-button", "aria-label": "Scroll", disabled: true, type: "button" },
    react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "scroll-button-text" },
            react_1.default.createElement("span", null, props.buttonText || "Scroll")),
        react_1.default.createElement("div", { className: "scroll-button-icon" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "circle-icon-new", icon: mps_icon_library_1.faArrowAltDown, title: "Scroll" }))))); };
exports.default = ScrollButton;
